module.exports = __webpack_public_path__ + "img/Swap.f4d49d43.svg";